import { FC } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { IPage, Page, PageTitle, PageTitleWithBack, PageTitleWrapper } from '../../components';
import { styleGuideLinks } from '../../helpers';
import { INavLink } from '../../models';

export const StyleGuidePage: FC<IPage> = ({ children, title, ...props }) => {
  const { path } = useRouteMatch();

  // find the link name based on the route;
  const selectedLink: INavLink | null =
    styleGuideLinks.find(link => link.url === path) ??
    styleGuideLinks
      .filter(link => !!link.links)
      .map(link => {
        return link.links.find(sublink => sublink.url === path);
      })[0];

  // set the pageTitle to the property name of the selected route otherwise fallback to the potal name
  const pageTitle = selectedLink?.name || title || 'Kitchen Sink';
  return (
    <Page title={pageTitle} sideBarLinks={styleGuideLinks}>
      <PageTitleWrapper>
        {path === '/kitchen-sink' ? (
          <PageTitle title={pageTitle} />
        ) : (
          <PageTitleWithBack
            title={pageTitle}
            backText="Back to Kitchen Sink"
            backUrl="/kitchen-sink"
          />
        )}
      </PageTitleWrapper>
      {children}
    </Page>
  );
};
